import { convertFbaSurvey } from "./convertFbaSurvey";

export async function parseFbaSurveyCsv(files, units='metric') {
  try {
    if (!files.length > 0) return false;
    
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      
      reader.readAsText(files[0]);
  
      let fbaSurveyData = [];
      
      reader.onload = async (event) => {
        let result = event.target.result;
  
        if (result.length > 0) {
          let data = result.split('\r\n');
          const headers = data?.splice(0,1)?.[0]?.split(','); // get csv headers
  
          let colIndices = {
            md: undefined,
            inc: undefined,
            tvd: undefined,
          };
      
          headers.forEach((col,i) => { // find indices of columns in the headers
            if (col.toLowerCase().match(/md/ig)) colIndices.md = i;
            if (col.toLowerCase().match(/inc/ig)) colIndices.inc = i;
            if (col.toLowerCase().match(/tvd/ig)) colIndices.tvd = i;
          });
  
  
          data.forEach(d => {
  
            if (d.replaceAll(/,/g,'')?.length > 0) {
  
              const row = d?.split(',');
              if (row[colIndices.md] > 0 && row[colIndices.inc] >= 0 && row[colIndices.tvd] > 0) {
                fbaSurveyData.push({
                  md: convertFbaSurvey(Number(row[colIndices.md]), units),
                  inc: Number(row[colIndices.inc]) || 0,
                  tvd: convertFbaSurvey(Number(row[colIndices.tvd]), units)
                });
              };
            };
          });
  
          // calculate displacement
          for (let i = 0; i < fbaSurveyData?.length; i++) {
            let tD = 0;
            if (i > 0) {
              const dD = (fbaSurveyData?.[i]?.md - fbaSurveyData?.[i-1]?.md) * Math.sin((degreesToRadians(fbaSurveyData?.[i-1]?.inc) + degreesToRadians(fbaSurveyData?.[i]?.inc)) / 2);
              tD = fbaSurveyData[i-1].totalDisplacement + dD;
            };
            fbaSurveyData[i].totalDisplacement = tD;
          };
        
          resolve({ fbaSurveyData, fileName: files?.[0]?.name, fileSize: files?.[0]?.size / 1000});
        };
      };
    });
  } catch (error) {
    console.log(error);
    return {fbaSurveyData: null, fileName: null, fileSize: null};
  };
};

function degreesToRadians(degrees) {
  return (degrees * Math.PI) / 180.0;
};